<template>
  <div>
    <!-- 这是radio -->
    <el-radio-group v-if="type == 'radio'"
      v-model="selected"
      :disabled="disabled"
      size="mini">
      <el-radio :label="item.val"
        v-for="(item,idx) in opts"
        v-bind:key="idx"
        size="mini">{{item.title}}</el-radio>
    </el-radio-group>

    <!-- 这是select -->
    <el-select v-if="type == 'select'"
      v-model="selected"
      :disabled="disabled"
      :placeholder="placeholder"
      clearable
      size="mini">
      <el-option v-for="(item,idx) in opts"
        :key="idx"
        :label="item.title"
        :value="item.val"></el-option>
    </el-select>

    <!-- 这是select -->
    <el-select v-if="type == 'multiSelect'"
      v-model="selected"
      :disabled="disabled"
      multiple
      :placeholder="placeholder"
      clearable
      style="width:300px"
      size="mini">
      <el-option v-for="(item,idx) in opts"
        :key="idx"
        :label="item.title"
        :value="item.val"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "CcConstantSelector",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    type: {
      // 类型: radio \ select \ multiSelect
      type: String,
      required: false,
      default: "select"
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    valType: {
      // 值类型
      type: String,
      required: false,
      default: "Number"
    },
    placeholder: {
      type: String,
      default: "請選擇"
    },
    value: [String, Number, Boolean, Array], // 可接受字符串、数字、Bool
    code: String, //常量的code
    api: String,
    afterRequest: {
      type: Function | String,
      default: ""
    }
  },
  data() {
    return {
      opts: [],
      selected: ""
    };
  },
  watch: {
    selected: {
      handler() {
        this.$emit("change", this.selected);
      },
      deep: true
    },
    value: {
      handler() {
        this.selected = this.value;
      }
    }
  },

  methods: {
    getConstants() {
      this.ccRequest
        .do(this.api, { code: this.code }, "GET")
        .then(res => {
          if (typeof this.afterRequest == "function") {
            this.opts.push(...(this.afterRequest(res) || []));
          } else {
            res.rows[0].children.forEach(child => {
              this.opts.push({
                val: this.changeType(child.val),
                title: child.title
              });
            });
          }
        })
        .catch(err => {});
    },
    changeType(val) {
      if (
        this.type == "radio" ||
        this.type == "select" ||
        !(val instanceof Array)
      ) {
        if (this.valType == "Number") {
          return val * 1;
        }
        if (this.valType == "String") {
          return val != null && val != undefined ? val + "" : null;
        }
        if (this.valType == "Boolean") {
          return val ? true : false;
        }
      } else {
        let result = [];
        val.forEach(item => {
          let v = null;
          if (this.valType == "Number") {
            v = item * 1;
          }
          if (this.valType == "String") {
            v = item != null && item != undefined ? item + "" : null;
          }
          if (this.valType == "Boolean") {
            v = item ? true : false;
          }
          result.push(v);
        });
        console.log("change type re=>", result);

        return result;
      }
    }
  },
  mounted() {
    this.getConstants();
    this.selected = this.changeType(this.value);
  }
};
</script>

<style>
</style>
